"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BillingWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _BillingWindowModule = _interopRequireDefault(require("./BillingWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _inputElements = require("../../../inputElements");

var _Item = _interopRequireDefault(require("../../../entities/Item/Item"));

var _BillingWindow = _interopRequireDefault(require("./BillingWindow.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MAX_ENTRIES_PER_PAGE = 12;
var MAX_ENTRIES_PER_TAB = MAX_ENTRIES_PER_PAGE * 3;

function BillingWindow(_ref) {
  var items = _ref.items,
      cashValue = _ref.cashValue,
      voucherValue = _ref.voucherValue,
      onCharge = _ref.onCharge,
      onPurchaseL = _ref.onPurchaseL,
      _ref$initialTab = _ref.initialTab,
      initialTab = _ref$initialTab === void 0 ? "PREMIUM" : _ref$initialTab,
      _ref$initialPage = _ref.initialPage,
      initialPage = _ref$initialPage === void 0 ? 1 : _ref$initialPage,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(initialTab),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = (0, _react.useState)(initialPage),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  items === null || items === void 0 ? void 0 : items.forEach(function (entries, key) {
    if (entries.length > MAX_ENTRIES_PER_TAB) console.error("BillingWindow only supports up to ".concat(MAX_ENTRIES_PER_TAB, " items per tab. ").concat(entries.length, " items were passed to tab '").concat(key, "'."));
  });
  var handleOnClickCharge = (0, _react.useCallback)(function () {
    if (onCharge) onCharge();
  }, [onCharge]);
  var handleOnClickPurchaseL = (0, _react.useCallback)(function () {
    if (onPurchaseL) onPurchaseL();
  }, [onPurchaseL]);
  var renderTabs = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.tabs
    }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_TAB,
      onClick: function onClick() {
        setCurrentPage(1);
        setCurrentTab("PREMIUM");
      },
      isDisabled: currentTab === "PREMIUM"
    }, formatMessage(_BillingWindow.default.premium)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_TAB,
      onClick: function onClick() {
        setCurrentPage(1);
        setCurrentTab("BUFF");
      },
      isDisabled: currentTab === "BUFF"
    }, formatMessage(_BillingWindow.default.buff)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_TAB,
      onClick: function onClick() {
        setCurrentPage(1);
        setCurrentTab("TRANSFORMATION");
      },
      isDisabled: currentTab === "TRANSFORMATION"
    }, formatMessage(_BillingWindow.default.transformation)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_TAB,
      onClick: function onClick() {
        setCurrentPage(1);
        setCurrentTab("POWER_UP");
      },
      isDisabled: currentTab === "POWER_UP"
    }, formatMessage(_BillingWindow.default.powerUp)));
  }, [currentTab, formatMessage]);
  var renderEntry = (0, _react.useCallback)(function (entry) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: entry.item.id,
      className: _BillingWindowModule.default.entry
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.name
    }, entry.item.model.name), /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.item
    }, /*#__PURE__*/_react.default.createElement(_Item.default, {
      item: entry.item
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.description
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.quantity
    }, formatMessage(_BillingWindow.default.quantity), ": ", entry.quantity || 1), /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.price
    }, entry.price, " ", formatMessage(_BillingWindow.default.herrny))), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING,
      className: _BillingWindowModule.default.button
    }, formatMessage(_BillingWindow.default.purchase)));
  }, [formatMessage]);
  var renderCurrentPage = (0, _react.useCallback)(function () {
    var currentTabEntries = items === null || items === void 0 ? void 0 : items.get(currentTab);
    if (!currentTabEntries) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    var currentPageEntries = currentTabEntries.slice((currentPage - 1) * MAX_ENTRIES_PER_PAGE, currentPage * MAX_ENTRIES_PER_PAGE);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.items
    }, currentPageEntries.map(function (entry) {
      return renderEntry(entry);
    }));
  }, [currentPage, currentTab, items, renderEntry]);
  var renderPagination = (0, _react.useCallback)(function () {
    var _items$get;

    var currentTabAmount = (items === null || items === void 0 ? void 0 : (_items$get = items.get(currentTab)) === null || _items$get === void 0 ? void 0 : _items$get.length) || 0;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.pagination
    }, currentTabAmount > MAX_ENTRIES_PER_PAGE && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_MAIN_NUMBER_1,
      className: _BillingWindowModule.default.page1Btn,
      isDisabled: currentPage === 1,
      onClick: function onClick() {
        return setCurrentPage(1);
      }
    }), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_MAIN_NUMBER_2,
      className: _BillingWindowModule.default.page2Btn,
      isDisabled: currentPage === 2,
      onClick: function onClick() {
        return setCurrentPage(2);
      }
    })), currentTabAmount > MAX_ENTRIES_PER_PAGE * 2 && /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_MAIN_NUMBER_3,
      className: _BillingWindowModule.default.page3Btn,
      isDisabled: currentPage === 3,
      onClick: function onClick() {
        return setCurrentPage(3);
      }
    }));
  }, [currentPage, currentTab, items]);
  var renderFooter = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.footer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.cashAmountLabel
    }, formatMessage(_BillingWindow.default.cashAmount)), /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.cashAmountValue
    }, cashValue || 0, " ", formatMessage(_BillingWindow.default.herrny)), /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.voucherLabel
    }, formatMessage(_BillingWindow.default.voucher)), /*#__PURE__*/_react.default.createElement("div", {
      className: _BillingWindowModule.default.voucherValue
    }, voucherValue || 0, " ", formatMessage(_BillingWindow.default.herrny)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_CHARGING,
      className: _BillingWindowModule.default.chargeBtn,
      onClick: handleOnClickCharge
    }, formatMessage(_BillingWindow.default.charge)), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: _inputElements.EButtonType.BILLING_HISTORY,
      className: _BillingWindowModule.default.purchaseLBtn,
      onClick: handleOnClickPurchaseL
    }, formatMessage(_BillingWindow.default.purchaseL)));
  }, [cashValue, formatMessage, handleOnClickCharge, handleOnClickPurchaseL, voucherValue]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_BillingWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _BillingWindowModule.default.dragHandler,
    classNameCloseBtn: _BillingWindowModule.default.closeBtn
  }), renderTabs(), /*#__PURE__*/_react.default.createElement("div", {
    className: _BillingWindowModule.default.notes
  }, "If you have an active premium service and use a new one, the time will be added to existing one."), renderCurrentPage(), renderPagination(), renderFooter());
}